export const FETCH_DEV_CHART_THIS_WEEK = "FETCH_DEV_CHART_THIS_WEEK";
export const FETCH_DEV_CHART_THIS_MONTH = "FETCH_DEV_CHART_THIS_MONTH";
export const FETCH_DEV_CHART_THIS_YEAR = "FETCH_DEV_CHART_THIS_YEAR";

export const fetchDevChartThisWeekData = (payload) => {
  return {
    type: FETCH_DEV_CHART_THIS_WEEK,
    payload: payload,
  };
};

export const fetchDevChartThisMonthData = (payload) => {
  return {
    type: FETCH_DEV_CHART_THIS_MONTH,
    payload: payload,
  };
};

export const fetchDevChartThisYearData = (payload) => {
  return {
    type: FETCH_DEV_CHART_THIS_YEAR,
    payload: payload,
  };
};
